import styled from 'styled-components';
import { Drawer } from 'antd';

export const LogoContainer = styled.div`
  padding: 20px 25px 10px 25px;
`;

export const DrawerElem = styled(Drawer)`
  display: none;
  @media (max-width: 1180px) {
    display: block;

    .ant-drawer-body {
      background-color: ${(props) => props.theme.colors.primary};
      color: ${(props) => props.theme.colors.textPrimary};
    }

    .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
      background-color: ${(props) => props.theme.colors.selectMenu};
    }

    .ant-menu-submenu-arrow {
      color: ${(props) => props.theme.colors.textPrimary};
      background-color: ${(props) => props.theme.colors.primary};
    }

    .ant-menu-item a {
      color: ${(props) => props.theme.colors.textPrimary};
    }

    .ant-menu a:hover {
      color: ${(props) => props.theme.colors.hoverMenu};
    }

    .ant-menu {
      color: ${(props) => props.theme.colors.textPrimary};
      background-color: ${(props) => props.theme.colors.primary};
    }
  }
`;
